import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProcessType } from '@models/process-type.model';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Log } from "ng2-logger";

@Component({
    selector: 'app-process-types-table',
    templateUrl: './process-types-table.component.html',
    styleUrls: ['./process-types-table.component.scss']
})
export class ProcessTypesTableComponent {
    _logger = Log.create(ProcessTypesTableComponent.name);
    @Input() processTypes: ProcessType[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    onPageChange(tableConfig: TableConfig) {
        this._logger.info("onPageChange::", tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info("onSortChange::", tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info("onFilterChange::", tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info("onFilterChange::", clickedItem);
        this.rowClick.emit(clickedItem);
    }

}
